import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";
import * as V from "styles/variables";

const ChartPictreeReportTrendSaitama = ({ reportTrend, tagOrder }) => {
  const option = useMemo(() => ({
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    legend: { data: tagOrder },
    grid: { left: 64, top: 48, right: 48, bottom: 32 },
    xAxis: { type: "category", data: reportTrend.map((row) => row.date) },
    yAxis: { type: "value", name: "報告件数" },
    color: V.genericColorPallette,
    series: tagOrder.map((tag) => ({
      name: tag,
      type: "bar",
      stack: "total",
      emphasis: { focus: "series" },
      data: reportTrend.map((row) => row[tag] || 0),
      barMaxWidth: 40,
    })),
  }), [reportTrend, tagOrder]);

  return <ReactEcharts option={option} theme="BarChartTheme" style={{ height: 400, width: "100%" }} />;
};

export default ChartPictreeReportTrendSaitama;
